import { constructPublicRoute } from '~/core/shared/utils/routing';

export const APPLICATION_WORKFLOW_BASE_URL = '/workflow';
export const APPLICATION_SESSION_EXPIRED_BASE_URL = `${APPLICATION_WORKFLOW_BASE_URL}/session-expired`;

export const APPLICATION_SYSTEM_ROUTES = {
  sessionExpired: constructPublicRoute(
    APPLICATION_SESSION_EXPIRED_BASE_URL,
    'Session expired',
  ),
  error: constructPublicRoute(
    `${APPLICATION_WORKFLOW_BASE_URL}/error`,
    'Error',
  ),
} as const;
